<app-title-bar rootBreadCrumbs="['i18n.core.navigation.admin']" titleText="i18n.domain.administration.fleet-list.title"></app-title-bar>

<div class="row">
  <div class="col-12 mb-2">
    <div class="header-wrapper">
      <app-client-autocomplete #clientAutocomplete [(selectedClient)]="selectedClient" class="client-autocomplete me-2"></app-client-autocomplete>
    @if(selectedClient) {
      <app-autocomplete #companyAutocomplete
                        [getDataFunction]="searchCompanyAutocompleteValues.bind(this)"
                        [(value)]="selectedCompany"
                        [allowObjectBinding]="true"
                        [isFormComponent]="false"
                        [enabled]="companyInitialySelected == false"
                        placeholder="i18n.domain.administration.fleet-list.select-company"
                        id="companyId">
      </app-autocomplete>
    }
    </div>
  </div>
</div>
@if(selectedClient) {
<div class="row">
  <div class="col-12">
    <ejs-grid #grid
              class="grid-with-toolbar grid-align-headers"
              width="100%"
              rowHeight="38"
              [dataSource]="data"
              [allowSorting]="true"
              [allowFiltering]="true"
              [filterSettings]='filterSettings'
              [editSettings]="customEditSettings"
              [toolbar]='toolbar'
              (actionBegin)='actionBegin($event)'
              (actionComplete)='actionComplete($event)'
              (beginEdit)="beginEdit($event)">
      <e-columns>
        <e-column field="id" [visible]="false" [isPrimaryKey]="true"></e-column>
        <e-column field="client.name"
                  headerText="{{'i18n.domain.administration.fleet-list.client' | translate}}"
                  clipMode="EllipsisWithTooltip"
                  [allowEditing]="false"
                  [allowFiltering]="false"
                  [allowSorting]="false"
                  [validationRules]="{ required: true }">
        </e-column>
        <e-column field="company.name"
                  headerText="{{'i18n.domain.administration.fleet-list.company' | translate}}"
                  clipMode="EllipsisWithTooltip"
                  [allowFiltering]="false">
          <ng-template #editTemplate let-data>
            <app-autocomplete #gridCompanyAutocomplete
                              [getDataFunction]="searchCompanyAutocompleteValues.bind(this)"
                              [(value)]="gridEditSelectedCompany"
                              [isFormComponent]="false"
                              [allowObjectBinding]="true"
                              placeholder="i18n.domain.reports.filter.fields.company-dropdown-placeholder"
                              id="company-autocomplete-{{data.id}}"
                              [enabled]="selectedCompany == null">
            </app-autocomplete>
          </ng-template>
        </e-column>
        <e-column field="countryCode"
                  headerText="{{'i18n.domain.administration.fleet-list.country' | translate}}"
                  clipMode="EllipsisWithTooltip"
                  type="string">
          <ng-template #editTemplate let-data>
              <app-autocomplete #countryAutocomplete
                                [getDataFunction]="getCountries.bind(this)"
                                [(value)]="gridEditSelectedCountryCode"
                                [isFormComponent]="true"
                                id="country">
              </app-autocomplete>
          </ng-template>
        </e-column>
        <e-column field="controlPlateNumber"
                  headerText="{{'i18n.domain.administration.fleet-list.control-plate-number' | translate}}"
                  clipMode="EllipsisWithTooltip"
                  type="string"
                  [validationRules]="controlPlateValidationRule">
          <ng-template #editTemplate let-data>
            <input type="text"
                   id="controlPlateNumber"
                   class="e-input"
                   name="controlPlateNumber"
                   autocomplete="off"
                   title="control plate number"
                   [value]="data.controlPlateNumber"
                   (input)="onControlPlateNumberInputChange(data, $event)" />
          </ng-template>
        </e-column>
        <e-column field="controlPlateType"
                  headerText="{{'i18n.domain.administration.fleet-list.control-plate-type' | translate}}"
                  clipMode="EllipsisWithTooltip"
                  [filter]="checkBoxFilter">
          <ng-template #filterItemTemplate let-data>
            {{formatControlPlateType(data) | translate}}
          </ng-template>
          <ng-template #template let-data>
            {{formatControlPlateType(data) | translate}}
          </ng-template>
          <ng-template #editTemplate let-data>
            <ejs-dropdownlist #controlPlateTypeDropDownList
                              id="controlPlateTypeEdit"
                              width="100%"
                              [showClearButton]="false"
                              [dataSource]="controlPlateTypeSelectionData"
                              [placeholder]="'i18n.domain.administration.fleet-list.select-control-plate-type' | translate"
                              [fields]="fields"
                              [(value)]="gridEditSelectedControlPlateType"
                              popupWidth="auto">
              <ng-template #itemTemplate let-data>
                {{data.text | translate}}
              </ng-template>
              <ng-template #valueTemplate let-data>
                <span class="full-height">{{data.text | translate}}</span>
              </ng-template>
            </ejs-dropdownlist>
          </ng-template>
        </e-column>
        <e-column field="type"
                  headerText="{{'i18n.domain.administration.fleet-list.type' | translate}}"
                  clipMode="EllipsisWithTooltip"
                  [filter]="checkBoxFilter">
          <ng-template #filterItemTemplate let-data>
            {{formatType(data) | translate}}
          </ng-template>
          <ng-template #template let-data>
            {{formatType(data) | translate}}
          </ng-template>
          <ng-template #editTemplate let-data>
            <ejs-dropdownlist #typeDropDownList
                              id="typeEdit"
                              width="100%"
                              [showClearButton]="false"
                              [dataSource]="typeSelectionData"
                              [placeholder]="'i18n.domain.administration.fleet-list.select-fleet-entry-type' | translate"
                              [fields]="fields"
                              [(value)]="gridEditSelectedType"
                              popupWidth="auto">
              <ng-template #itemTemplate let-data>
                {{data.text | translate}}
              </ng-template>
              <ng-template #valueTemplate let-data>
                <span class="full-height">{{data.text | translate}}</span>
              </ng-template>
            </ejs-dropdownlist>
          </ng-template>
        </e-column>
        <e-column field="tagIdent"
                  headerText="{{'i18n.domain.administration.fleet-list.tagIdent' | translate}}"
                  clipMode="EllipsisWithTooltip"
                  type="string"
                  [validationRules]="{ required: false, maxLength: 50 }">
        </e-column>
        <e-column field="description"
                  headerText="{{'i18n.domain.administration.fleet-list.description' | translate}}"
                  clipMode="EllipsisWithTooltip"
                  type="string">
        </e-column>
        <e-column [commands]="customGridCommands" width="90px"></e-column>
      </e-columns>
    </ejs-grid>
  </div>
</div>
}
